<style scoped>
.simple-title {
  font-size: 20px;
  text-align: center;
}
</style>

<template>
  <div class="simple-title bottom-border mb-2">
    {{ title }}
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/utils/SimpleTitle.vue